<mat-label class="subHeading">Age</mat-label>
<div formGroupName="age" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="2" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="2" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        ageForm.controls['from'].hasError('small')
        ||
        ageForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
